import React from 'react';
import ProgressIndicator from '../../../components/ui/ProgressIndicator';

const ProgressSteps = ({ currentStep = 1, className = '' }) => {
  const steps = [
    {
      label: 'Setup',
      description: 'Role & Level'
    },
    {
      label: 'Questions',
      description: 'Assessment'
    },
    {
      label: 'Analysis',
      description: 'AI Processing'
    },
    {
      label: 'Results',
      description: 'Your Plan'
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">Assessment Progress</h3>
        <p className="text-sm text-muted-foreground">
          Step {currentStep} of {steps?.length} - Complete your career assessment
        </p>
      </div>
      <ProgressIndicator
        currentStep={currentStep}
        totalSteps={steps?.length}
        type="steps"
        size="default"
        showLabels={true}
        steps={steps}
        className="w-full"
      />
      <div className="mt-6 text-center">
        <div className="text-sm text-muted-foreground">
          {currentStep === 1 && "Select your occupation and experience level to begin"}
          {currentStep === 2 && "Answer role-specific questions about your career"}
          {currentStep === 3 && "AI is analyzing your responses and generating insights"}
          {currentStep === 4 && "Review your personalized career development plan"}
        </div>
      </div>
    </div>
  );
};

export default ProgressSteps;